import { render, staticRenderFns } from "./ContentModal.vue?vue&type=template&id=5faf21d0&scoped=true"
import script from "./ContentModal.vue?vue&type=script&lang=js"
export * from "./ContentModal.vue?vue&type=script&lang=js"
import style0 from "./ContentModal.vue?vue&type=style&index=0&id=5faf21d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf21d0",
  null
  
)

export default component.exports